import { render, staticRenderFns } from "./Typography3.vue?vue&type=template&id=209a3744&scoped=true"
import script from "./Typography3.vue?vue&type=script&lang=js"
export * from "./Typography3.vue?vue&type=script&lang=js"
import style0 from "./Typography3.vue?vue&type=style&index=0&id=209a3744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209a3744",
  null
  
)

export default component.exports